import React from 'react'

function TwistOutletDDVG() {
  return (
    <embed src="\pdfs\E1.1.6.4_DD-VG_Variable_twist_outlet-jet_streigtener_01.2018-kr.pdf" width="100%" height="2100px" />
  )
}

export default TwistOutletDDVG